import { render, staticRenderFns } from "./header1.vue?vue&type=template&id=fe974e1c&scoped=true"
import script from "./header1.vue?vue&type=script&lang=js"
export * from "./header1.vue?vue&type=script&lang=js"
import style0 from "./header1.vue?vue&type=style&index=0&id=fe974e1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe974e1c",
  null
  
)

export default component.exports